import React from "react";
import { useAuthService } from "../Context/AuthContext";
import { Navigate, useLocation } from "react-router";
import { useSearchParams } from "react-router-dom";
import OnboardRegisteredUser from "../Components/Auth Components/OnboardRegisteredUser";
import { needsSsoOnboarding } from "../Helpers/userProfile";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const { user, anonUser } = useAuthService();
  if (user === undefined) return <div></div>;
  if (user === null) {
    return (
      <Navigate to={"/login"} state={{ backTo: `${location.pathname}` }} />
    );
  }

  if (needsSsoOnboarding(user)) {
    return <Navigate to="/onboarding" />;
  }

  // Check if user is missing required fields
  const isMissingName = !user.name || user.name.trim().length < 3;
  const isMissingLanguage = !user.language || user.language === "";
  const isMissingCallLanguage = !user.call_language || user.call_language === "";

  if (isMissingName || isMissingLanguage || isMissingCallLanguage) {
    return <OnboardRegisteredUser />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
